/**
 *
 * TableTextSkeleton
 *
 */

import React, { memo } from 'react';

import Skeleton from '..';

function TableTextSkeleton(props) {
  return <Skeleton height={12} {...props} />;
}

export default memo(TableTextSkeleton);
